<template>
  <text-input
    v-model="currentValue"
    :class="{'password-input': 1, 'is-showing': show}"
    :placeholder="placeholder"
    :helper-text="helperText"
    :error="error"
    :button="{name: 'visibility_off_outline'}"
    :type="show ? 'text' : 'password'"
    @submit="toggleShow"
    :disabled="disabled"
    :required="required"
    isRequired/>
    
</template>

<script>
  import input from '../../../mixins/input'
  import TextInput from '../../../components/ui/inputs/TextInput'

  /**
   * This is a nice password input box with a toggle show button
   */
  export default {
    name: 'password-input',

    mixins: [input],
    props: {
      disabled: {
        type: Boolean,
        default: false
      },
      isRequired: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        show: false
      }
    },

    components: {
      TextInput
    },

    methods: {
      toggleShow() {
        this.show = !this.show
      }
    }
  }
</script>

<style lang="sass">
  @import '../../../styles/base/variables'

  .password-input
    .sprite
      fill: $color-input-icon

    &.is-showing
      .sprite
        fill: $color-input-icon-active

      &.is-invalid
        .sprite
          fill: $color-input-icon-error
</style>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/inputs/PasswordInput.vue